import { render, staticRenderFns } from "./PaymentProfileSync.vue?vue&type=template&id=3a21a19a&scoped=true"
import script from "./PaymentProfileSync.vue?vue&type=script&lang=ts"
export * from "./PaymentProfileSync.vue?vue&type=script&lang=ts"
import style0 from "./PaymentProfileSync.vue?vue&type=style&index=0&id=3a21a19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a21a19a",
  null
  
)

export default component.exports